import { bold, nextLine, subscript } from "components/mlpaUiComponents/LegalNote/lib";

export default {
  certificateUploadProcess: {
    createNew: {
      description: `Laden Sie hier ein neues Zertifikat hoch.<br>Sie können die Daten manuell eintragen oder eine Datei mit den Netzanschlusswerten hochladen.`,
      title: "Neues Zertifikat",
    },
    replaceExisting: {
      description: `Ersetzen Sie hier ein Zertifikat.<br>Gilt nur für die Normen VDE-AR-N 4110, VDE-AR-N 4120 und VDE-AR-N 4130.`,
      title: "Vorhandenes Zertifikat ersetzen",
      extendTitle: "Vorhandenes Zertifikat erweitern",
    },
    gridFormingCertificate: {
      description: `Laden Sie hier ein Zertifikat hoch, welches die Anforderungen des VDE FNN Hinweises Version 2.1 <b>"Technische Anforderungen an Netzbildende Eigenschaften inklusive der Bereitstellung von Momentanreserve"</b> erfüllt.<br />Die Matrixparameter lassen sich auch bequem über eine erweiterte Liste der Netzanschlusswerte importieren, welche Sie direkt auf den nachfolgenden Formularen herunterladen können.`,
      uploadFormDescription: `Sie können hier eine erweiterte Liste der Netzanschlusswerte herunterladen, mit der sich auch die Angaben zur Momentanreserve importieren lassen.`,
      downloadLinkDE: "Deutsche Version",
      downloadLinkEN: "Englische Version",
      title: "Neues netzbildende Einheiten Zertifikat",
      replaceTitle: "Vorhandenes netzbildende Einheiten Zertifikat ersetzen",
      extendTitle: "Vorhandenes netzbildende Einheiten Zertifikat erweitern",
    },
    gridFormingCertificateEdit: {
      description: `Sie können die Daten der Matrix-Parameter und Netzanschlusswerte manuell bearbeiten oder mittels einer Liste der VDE aktualisieren.<br />Überprüfen Sie dann die Korrektheit der Daten und klicken Sie auf Senden.`,
      title: "Zertifikat netzbildender Einheiten bearbeiten",
    },
    edit: {
      description: "Bearbeiten Sie ein existierendes Zertifikat.",
      title: "Vorhandenes Zertifikat bearbeiten",
    },
    import: {
      description: "Bearbeiten Sie ein migriertes Zertifikat.",
      title: "Migriertes Zertifikat bearbeiten",
    },
    replaceCertificatePropmt: "Geben Sie die Zertifikatsnummer des Zertifikats ein, das Sie ersetzen möchten!",
    withdrawCertificateOption: "Zurückgezogen (ersetzt durch)",
    extendValidityOption: "Gültig (erweitert durch)",
  },
  noOptionsText: "Keine Zertifikate zum Ersetzen gefunden",
  addUnit: "Einheit hinzufügen",
  createUnit: "Einheit erstellen",
  linkexistingUnit: "Vorhandene Einheit verknüpfen",
  linkexistingUnitDescription: "Modell Namen oder Seriennummer eingeben",
  animationTitle: "...Daten werden geladen",
  noCertificateTypeSelected:
    "Bitte wählen Sie zunächst die Art des Nachweisdokuments (1.12), um Einheitenparameter angeben zu können!",
  category: "Kategory",
  certificationAuthority: "Zertifizierungsstelle",
  certificateFileTooLarge: "Die Datei ist zu groß. Bitte verwenden Sie eine Datei mit einer Größe von max 20 MB.",
  certificateIssueDate: "Ausgabedatum des Zertifikates",
  comment:
    "Bitte überprüfen Sie die gescannten Daten aus dem hochgeladenen Datenblatt und nehmen Sie gegebenenfalls Anpassungen an den Geräteparametern vor. Klicken Sie zur Bestätigung auf die Schaltfläche „Senden“.",
  dataSheet: "Data Sheet",
  discardChanges: "Änderungen verwerfen?",
  docs: "Hochgeladene Dokumente",
  errorMessages: {
    nonLatinCharacters: "Bitte verwenden Sie nur lateinische Buchstaben (A-Z)",
    categoryInvalidForNorm: "Diese Kategorie ist für diese Norm nicht gültig!",
    categoryRequired: "Die Kategorie ist erforderlich!",
    norm4105NotSupportedForGridForming: "Norm VDE-AR-N 4105 wird für netzbildende Zertifikate nicht unterstützt.",
    norm4105NotSupportedForGridFormingTitle: "Norm VDE-AR-N 4105 nicht unterstützt",
    categoryNotSupportedForGridForming:
      "Die folgenden Kategorien werden für netzbildende Zertifikate nicht unterstützt: NA-Schutz, PAV,E-Überwachung, Spannungsregler, Schutzgerät (Zwischengelagert), EZA-Regler, Andere.",
    categoryNotSupportedForGridFormingTitle: "Kategorie nicht unterstützt",
    certificateTypeNotSupportedForGridForming:
      "Herstellererklärung wird für netzbildende Zertifikate nicht unterstützt.",
    certificateTypeNotSupportedForGridFormingTitle: "Nachweisdokument nicht unterstützt",
    someUnitsHaveErrors: "Einige Einheiten haben Fehler",
    certificateAlreadyExists: "Dieses Zertifikat existiert bereits",
    certificateCoverSheetRequired: "Das Deckblatt des Zertifikats ist erforderlich",
    perturbationsTestReportRequired: "Das Dokument Zertifikat/Prüfbericht NA-Schutz ist erforderlich",
    softwareVersionRequired: "Die Software-Version ist erforderlich",
    manufacturerUnitAlreadyExists: "Dieser Hersteller hat bereits eine Einheit mit diesem Namen",
    manufacturerIsRequired: "Der Hersteller ist erforderlich",
    manufactucturerIdDifferentToUnitManufacturer:
      "Der Hersteller stimmt nicht mit dem Hersteller der verknüpfen Einheite(s) überein",
    modelAlreadyExists: "Dieses Modell existiert bereits",
    normRequired: "Die Norm ist erforderlich",
    requieredIfGreater10: "Dieses Feld ist erforderlich, wenn Norm größer oder gleich 10 ist",
    unitHasCountErrors: "Die Einheit {unitName} hat {errorCount} Fehler",
    duplicateUnitNames: "Ein Zertifikat kann nicht merhere Einheiten mit dem gleichen Namen haben",
    requieredIfCategory: "Dieses Feld ist bei der Kombination aus Norm & Kategorie erforderlich",
    requieredIfCategoryAndMaxRated:
      "Dieses Feld ist bei der Kombination aus Norm, Kategorie & Maximaler Wirkleistung erforderlich",
    tooManyFractionalDigits:
      "Eingabe entspricht nicht den Formatvorgaben, maximal {maxDecPlaces} Nachkommastelle(n) möglich.",
    withTG8Rev25ConformityOnNorm5: "Dieses Feld ist nur für Normen größer oder gleich 10 zulässig",
    withTG8Rev25ConformityRequired: "Dieses Feld ist erforderlich, wenn TG8 Rev. 9 Konformität aktiviert ist",
    fileReadErrorTitle: "Datei konnte nicht gelesen werden",
    fileReadError:
      "Die ausgewählte Datei konnte nicht gelesen werden. Bitte überprüfen Sie die Datei und versuchen Sie es erneut.",
    required: "Dieses Feld ist  erforderlich",
    aggregatedFileSize:
      "Die zum Hochladen ausgewählten Dateien sind zu groß. Bitte laden Sie Dateien mit einer Gesamtgröße von max 30 MB hoch.",
    newUnitRequiredInExtendedValidityFlow:
      "Um die Gültigkeit des Zertifikats zu verlängern, fügen Sie bitte eine neue Einheit hinzu oder ändern Sie mindestens eines der folgenden Felder: Ausgabedatum, Norm, Einschränkungen oder Softwareversion.",
    matrixParametersRequired: "Alle Felder zu Momentanreserveparametern sind erforderlich",
    matrixParameterRangeRequired: `Alle Werte eines parametrierbaren Bereichs müssen ausgefüllt werden`,
    matrixParametersInvalidFormat: "Momentanreserveparameter haben ein ungültiges Format",
    matrixParametersTaMinRequired: "taMin Felder müssen ausgefüllt werden",
    matrixParametersTaMaxRequired: "taMax Felder müssen ausgefüllt werden",
    matrixParametersAllFieldsRequired: `Alle Felder in {section} müssen ausgefüllt werden`,
    matrixParametersZeroNotAllowed: "Alle Felder in {section} müssen mit Werten ungleich Null ausgefüllt werden",
    matrixParametersZwMustBeGreaterThanZero: "Wert der wirksamen Impedanz muss größer als 0 sein",
    matrixParametersOrderingViolation:
      "Die Werte für {field} müssen in aufsteigender Reihenfolge sein: 0 < T_A,min <= T_A,1 < ... < T_A,n <= T_A,max",
    matrixParametersDuplicateTaValue: "Keine Duplikate in Werten von Anlaufzeitkonstanten erlaubt",
    matrixParametersError: "Fehler in Momentanreserveparametern",
  },
  field: {
    category: "Kategory",
    certificationAuthority: "Zertifizierungsstelle",
    certificateIssueDate: "Ausgabedatum des Zertifikates",
    manufacturer: "Hersteller",
    validityStatus: "Gültigkeitsstatus",
  },
  feedBack: {
    error: {
      title: "Fehler beim Erstellen des Zertifikats",
      body: "Es gab ein Problem beim Erstellen des Zertifikats. Bitte versuchen Sie es erneut.",
    },
    success: {
      title: "Zertifikat Erstellt",
      body: "Das Zertifikat und die zugehörigen Einheiten wurden erfolgreich hochgeladen.",
    },
    successReplace: {
      title: "Zertifikat ersetzt",
      body: "Das neue Zertifikat und die zugehörigen Einheiten wurden erfolgreich hochgeladen. Das bisherige Zertifikat wurde erfolgreich ersetzt.",
    },
    successExtend: {
      title: "Zertifikat erweitert",
      body: "Das neue Zertifikat wurde erfolgreich als Erweiterung erstellt. Alle Einheiten aus der Zertifikatskette wurden automatisch mit dem neuen Zertifikat verknüpft.",
    },
    successEdit: {
      title: "Zertifikat geändert",
      body: "Das Zertifikat und die zugehörigen Einheiten wurden erfolgreich geändert.",
    },
    successEditChained: {
      title: "Zertifikat geändert",
      body: "Das Zertifikat und die zugehörigen Einheiten wurden erfolgreich geändert. Änderungen am Status werden automatisch auf ALLE Zertifikate in dieser Zertifkatskette angewendet!",
    },
  },
  info: "Zertifikatsinformationen",
  label: "Zertifikat hochladen",
  pdfCertificate: "PDF Certificate",
  placeHolderCertificationBodyForManufacturersDeclaration: "Herstellererklärung ohne Zertifizierungsstelle",
  renameFile: "Datei umbenennen",
  resetButtonLabel: "Änderungen zurücksetzen",
  title: "Einheiten & Parameter",
  unsavedChanges:
    "Sie haben nicht gespeicherte Änderungen vorgenommen. Wenn Sie den Upload-Vorgang verlassen, gehen alle Änderungen verloren. Möchten Sie den Vorgang verlassen und alle Änderungen verwerfen?",
  uploadFormDescription:
    "Sie können eine Excel-Datei für die automatische Datenüberprüfung hochladen. Überprüfen Sie dann die Korrektheit der Daten und klicken Sie auf Senden. Alternativ können Sie die erforderlichen Daten manuell eingeben, überprüfen und das Formular senden.",
  updateFormDescription: {
    import: `Sie können entweder die Parameter aus einer Excel-Vorlage übernehmen oder diese manuell eingeben. Überprüfen Sie anschließend die Korrektheit der Daten und senden Sie das Formular ab.
      ${nextLine()}${bold("Bitte beachten Sie:")}${nextLine()}
      Beim Upload einer Excel-Vorlage werden bei migrierten Zertifikaten nur die Leistungsparameter (1.20 - 1.68) übernommen. Alle Werte, die das Zertifikat betreffen (1.01 - 1.19) werden nicht beachtet.
      ${nextLine()}Diese müssen ggf. manuell angepasst werden.
      ${nextLine()}Mit der ersten Bearbeitung verliert das Zertifikat das Attribut „migriert“.
    `,
  },
  uploadFormTitle: "Zertifikat hochladen",
  noUnitsFound: "Keine passenden Einheiten gefunden",
  fileVisibility: {
    modalTitle: "Dateisichtbarkeit konfigurieren",
    description:
      "Steuern Sie, welche Rollen und Organisationen auf diese Datei zugreifen können. Leer lassen für Standardsichtbarkeit.",
    grantAccessToRoles: "Zugriff für Rollen gewähren",
    grantAccessToTenants: "Zugriff für Organisationen gewähren",
    searchTenants: "Nach Organisationen suchen...",
    summary: "Zugriff gewährt für:",
    configureAccess: "Dateisichtbarkeit konfigurieren",
    accessGrantedTo: "Zugriff gewährt für",
  },
  unitVisibility: {
    modalTitle: "Sichtbarkeit von Anlagenparametern konfigurieren",
    description:
      "Steuern Sie, welche Rollen und Organisationen auf Anlagenparameter zugreifen können. Leer lassen für Standardsichtbarkeit.",
    grantAccessToRoles: "Zugriff für Rollen gewähren",
    grantAccessToTenants: "Zugriff für Organisationen gewähren",
    searchTenants: "Nach Organisationen suchen...",
    summary: "Zugriff gewährt für:",
    configureAccess: "Sichtbarkeit von Anlagenparametern konfigurieren",
    accessGrantedTo: "Zugriff gewährt für",
  },
  matrixVisibility: {
    modalTitle: "Sichtbarkeit von Matrixparametern konfigurieren",
    description:
      "Steuern Sie, welche Rollen und Organisationen auf Matrixparameter zugreifen können. Leer lassen für Standardsichtbarkeit.",
    grantAccessToRoles: "Zugriff für Rollen gewähren",
    grantAccessToTenants: "Zugriff für Organisationen gewähren",
    searchTenants: "Nach Organisationen suchen...",
    summary: "Zugriff gewährt für:",
    configureAccess: "Sichtbarkeit von Matrixparametern konfigurieren",
    accessGrantedTo: "Zugriff gewährt für",
  },
  gridFormingTypeSelection: {
    title: "Auswahl Erzeugungseinheit",
    type1: {
      title: "Typ 1",
      description: "Erzeugungseinheiten mit Synchrongenerator",
    },
    type2: {
      title: "Typ 2",
      description: "Erzeugungseinheiten mit Umrichter oder Asynchrongenerator",
    },
  },
  matrixParametersType1: {
    title: "Trägheitsparameter",
    taGenLabel: "Anlaufzeitkonstante des Generators",
    taZusLabel: "Anlaufzeitkonstante der zusätzlichen Schwungmasse mit gekuppeltem Generator",
    taGesLabel: "Massenträgheit des gesamten Wellenstrangs (Gesamtsystem)",
    labelColumnHeader: "Bezeichnung",
    unitColumnHeader: "Einheit",
    valueColumnHeader: "Wert",
    sumValidationError: `T${subscript("A,gen")} + T${subscript("A,zus")} muss gleich T${subscript("A,ges")} sein`,
    allFieldsRequired: "Alle Felder zu Momentanreserveparametern müssen ausgefüllt werden",
  },
  enterValue: "Wert eingeben",
  addStartUpTimeConstant: "Parametrierbaren Bereich hinzufügen",
  addEffectiveImpedance: "Wirksame Impedanz hinzufügen",
};
